export enum EKwikUIInputNumberDecimal {
  NOT_ZERO = "not-zero",
  ALWAYS = "always",
  NEVER = "never"
}
export const VKwikUIInputNumberDecimal = [
  EKwikUIInputNumberDecimal.NOT_ZERO,
  EKwikUIInputNumberDecimal.ALWAYS,
  EKwikUIInputNumberDecimal.NEVER
] as const;

export type TKwikUIInputNumberDecimal =
  (typeof VKwikUIInputNumberDecimal)[number];

// Size Attribute
export enum EKwikUIInputNumberSize {
  S = "s",
  M = "m",
  L = "l"
}
export const VKwikUIInputNumberSize = [
  EKwikUIInputNumberSize.S,
  EKwikUIInputNumberSize.M,
  EKwikUIInputNumberSize.L
] as const;

export type TKwikUIInputNumberSize = (typeof VKwikUIInputNumberSize)[number];
